<template>
  <div>
    <el-button
      :icon="iconName?'el-icon-' + iconName:''"
      :style="{ backgroundColor: backgroundColor }"
      :class="className"
      @click="hanldClick()"
    >
      <slot name="svgImg"></slot> {{ text }}
    </el-button>
  </div>
</template>

<script>
export default {
  props: {
    svgImg: { type: String, default: "" },
    text: {
      type: String,
      default: "暂无"
    },
    iconName: {
      type: String,
      default: "search"
    },
    className: {
      type: String,
      default: ""
    },
    backgroundColor: {
      type: String,
      default: "fff"
    }
  },
  methods: {
    hanldClick(e) {
      this.$emit("emit", e);
    }
  }
};
</script>

<style lang="scss" scoped>
>>> [class^="el-icon-"] {
  background-color: white !important;
  padding: 8px;
  margin-right: 5rpx;
  border-radius: 12px;
  color: #0f1741;
  // width: 30px;height:30px;;
}

.el-button {
  color: #0f1741;
  padding: 10px;
  border: none;
  border-radius: 18px;
  margin-left: 8px;
  display: flex;align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Vbutton/index.vue